import React, { useEffect } from "react";
import { Skeleton } from "@material-ui/lab";
import { getPracticeDocuments } from "apiHandler/actions/scribe";
import { displayDateFormatter } from "components/helpers";
import { useUserData } from "components/customHooks/userDataContext";
import { Modal } from "@mui/material";

const headers = [
  { label: "Type", value: "doc_type" },
  { label: "Title", value: "doc_title" },
  { label: "Description", value: "doc_description" },
  { label: "Date", value: "created_date" },
];

const AuditHistory = (props) => {
  const { documents, setDocuments, practice_id } = props;
  const userData = useUserData();
  const token = userData?.access_token;

  useEffect(() => {
    if (documents === null) fetchDocuments();
  }, []);

  const fetchDocuments = async () => {
    const payload = {
      type: "Scribe",
      search_criteria: {
        practice_id: practice_id.toString(),
        scribe_id: userData.email,
      },
    };
    const response = await getPracticeDocuments(payload, token);
    setDocuments(response || []);
  };

  return (
    <Modal onClose={props.onClose} open={true}>
      <div className="dictation-common-modal">
        <h3 className="dcm-title">
          Practice Documents
          <span className="dcm-sub-title">( Id - {practice_id} )</span>
        </h3>
        <div className="dcm-status">
          {documents === null ? (
            <div>
              <Skeleton variant="text" height={50} />
              <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
              <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
              <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
              <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
              <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
            </div>
          ) : (
            <table className="dcm-table">
              <thead>
                <tr>
                  {headers.map((h) => (
                    <th key={h.label} className="dcm-th">
                      {h.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {documents.map((d) => (
                  <tr className="dcm-tr" key={d.id}>
                    <td className="dcm-td">{d.doc_type}</td>
                    <td className="dcm-td">
                      <a
                        href={d.s3_url}
                        target="_blank"
                        className="dcm-td-link"
                        rel="noreferrer"
                      >
                        {d.doc_title}
                      </a>
                    </td>
                    <td className="dcm-td">{d.doc_description}</td>
                    <td className="dcm-td">
                      {displayDateFormatter(d.created_date)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default AuditHistory;
